import { useMutation } from "urql";

import { CreateLimitRequestExceptionDocument } from "../../../graphql/generated.ts";

export const useCreateLimitRequestException = () =>
  useMutation(CreateLimitRequestExceptionDocument);
